export default function YouTubeEmbed({ videoId, className = "" }) {
  if (!videoId) return null;
  return (
    <div className={`relative w-full overflow-hidden rounded-xl border border-jj bg-black ${className}`} style={{ paddingTop: "56.25%" }}>
      <iframe
        className="absolute inset-0 w-full h-full"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        data-testid={`yt-embed-${videoId}`}
      />
    </div>
  );
}
